module.exports = __webpack_public_path__ + "img/bold-blue-checkbox-checked.59a73343.svg";